import React from 'react';
import Header from '../elements/Header';
import PropTypes from 'prop-types';
import { __ } from 'i18n-for-browser';
import actions from '../../actions';

import DifficultyAwareComponent from "../DifficultyAwareComponent";
import connect from "react-redux/es/connect/connect";
import ListButton from '../elements/ListButton';

import {
  getImageText,
  getImage,
  getText,
  getEconomieFeedback,
  getEconomieFeedbackFormatted,
  checkRead, getUnreadWinstGlobas, getUnreadVerliesGlobas,
} from "../../helpers/feedbackHelpers";
import {
  getIcon as getPolicyChoiceIcon,
  getOplossingTitle
} from "../../helpers/policyChoiceHelper";
import UpGlobas from '../../assets/img/icons/economy/up-globas.svg';
import MinGlobas from '../../assets/img/icons/economy/min-globas.svg';
import {ministryIcons,belastingIcons} from "../../assets/assets";

import FeedbackImage from "../elements/feedback/FeedbackImage";
import ContentContainer from "../elements/ContentContainer";
import config from "../../config";

const { updateRead } = actions.feedback;

class FeedbackOverview extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.match.params.type,
      showFeedback: false
    };
  }

  getIcon = (fb) => {
    if (fb.type === 'BELASTING') {
      if ((fb.niveau === 'Basic')) {
        return belastingIcons['LB'];
      }
      return belastingIcons[fb.belastingsoort];
    }
    if (fb.type === 'BELEIDSKEUZE') {
      return getPolicyChoiceIcon(fb);
    }
    return ministryIcons[fb.ministerie];
  }

  getTitle = (fb) => {
    let title = `${__('sim_effect_vanuit')}: `;
    if (fb.type === 'BELASTING') {
      if(fb.niveau === 'Basic') {
        return title += __('sim_belastingkeuze');
      }
      return title += __(fb.belastingsoort || __('sim_belasting'));
    }
    if (fb.type === 'BELEIDSKEUZE') {
      return title += getOplossingTitle(fb, this.props.gameState.language);
    }
    return title += __(fb.ministerie);
  }

  setShowFeedback(i, id, read, feedback) {
    if (this.state.showFeedback === i) {
      this.setState({
        showFeedback: false
      })
    } else {
      if (!read) {
        feedback.read.economie = true;

        const array = feedback.read;

        array.economie = true;

        this.props.dispatch(updateRead(id, array));
      }

      this.setState({
        showFeedback: i
      })
    }
  }

  renderLaag() {
    const { gameState, feedback, group } = this.props;
    const { state } = this;
    const {prevRoundFeedbackData } = feedback;
    const {prevRoundSum} = gameState;
    if(!prevRoundSum) return null;
    const {OneTimeEffect} = prevRoundSum;

    let unreadFeedback = 0;

    if (state.type === 'profit') {
      unreadFeedback = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    } else {
      unreadFeedback = getUnreadVerliesGlobas(prevRoundFeedbackData).length;
    }

    const allFeedback = getEconomieFeedback(prevRoundFeedbackData, state.type);

    let openFeedback = false;

    if (this.props.match.params.id) {
      allFeedback.find((f, i) => {
        if (f.omschrijving === this.props.match.params.id) {
          openFeedback = i;
          return f;
        }
        return false;
      }, this)
    }

    const displayPoints = Math.abs(this.state.type === 'profit' ? OneTimeEffect.WG : OneTimeEffect.VG);
    const pointsGlyph = (this.state.type === 'profit' ? "+ " : "- ");
    const isStartSituation = (group.Rounds.length === 2);


    return (
      <div>
        <Header history={this.props.history} historic={false} buttonType='close' viewType='list' showTitle={false}/>

        <div className='container ministry-container ministry-container--economy'>
          <ListButton
            bgColor='blue'
            title={(state.type === 'profit' ? __('sim_winstglobas') : __('sim_verliesglobas'))}
            icon={(state.type === 'profit' ? UpGlobas : MinGlobas)}
            feedbackCount={unreadFeedback.length}
            arrow={true}
            isGlobas={true}
            dashForZero={true}
            points={isStartSituation ? '-' : (displayPoints === 0 ? 0 : pointsGlyph + displayPoints)}
            popupId={(state.type === 'profit' ? 'mlgvtwinstglobas' : 'mlgvtverliesglobas')}
          />
          <div className='feedback-list'>
            {allFeedback.map((feedback, i) => {
              return (
                <div className={'feedback-container-low'} key={i}>
                  <ListButton
                    read={checkRead(feedback, false, 0, true)}
                    bgColor='grey'
                    title={this.getTitle(feedback)}
                    icon={this.getIcon(feedback)}
                    arrow={true}
                    feedback={true}
                    thumbnail={`${config.mediaUrl}${getImage(feedback.economie)}.jpeg`}
                    points={
                      ( state.type === 'profit' ?
                        '+ '
                        : null ) +
                      feedback.economie.winstverliesglobas
                    }
                    isGlobas={true}
                    onClick={() => this.setShowFeedback(i, feedback.id, checkRead(feedback, false, 0, true), feedback)}
                  />
                  <div className={this.state.showFeedback === i || (openFeedback === i && !this.state.showFeedback) ? 'collapsed-feedback-container show' : 'collapsed-feedback-container'}>
                    <FeedbackImage
                      // disaster={false}
                      description={getImageText(feedback.economie, gameState.language)}
                      image={getImage(feedback.economie)}
                    />
                    <ContentContainer>
                      <div dangerouslySetInnerHTML={{ __html: getText(feedback.economie, gameState.language) }}/>
                    </ContentContainer>
                    <span className={'feedback-list-line'}/>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    );
  }

  renderHoog() {
    const { gameState, feedback, group } = this.props;
    const { state } = this;
    const {prevRoundFeedbackData } = feedback;
    const {prevRoundSum} = gameState;
    if(!prevRoundSum) return null;
    const {OneTimeEffect} = prevRoundSum;

    let unreadFeedback = 0;

    if (state.type === 'profit') {
      unreadFeedback = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    } else {
      unreadFeedback = getUnreadVerliesGlobas(prevRoundFeedbackData).length;
    }

    const feedbackFormatted = getEconomieFeedbackFormatted(prevRoundFeedbackData, state.type, gameState);

    const displayPoints = Math.abs(this.state.type === 'profit' ? OneTimeEffect.WG : OneTimeEffect.VG);
    const pointsGlyph = (this.state.type === 'profit' ? "+ " : "- ");
    const isStartSituation = (group.Rounds.length === 2);

    return (
      <div>
        <Header history={this.props.history} historic={false} buttonType='close' viewType='list' showTitle={false}/>

        <div className='container ministry-container ministry-container--economy'>
          <ListButton
            bgColor='blue'
            title={(state.type === 'profit' ? __("sim_winstglobas") : __("sim_verliesglobas"))}
            icon={(state.type === 'profit' ? UpGlobas : MinGlobas)}
            feedbackCount={unreadFeedback}
            arrow={true}
            isGlobas={true}
            dashForZero={true}
            points={isStartSituation ? '-' : (displayPoints === 0 ? 0 : pointsGlyph + displayPoints)}
            popupId={(state.type === 'profit' ? 'mhgvtwinstglobas' : 'mhgvtverliesglobas')}
          />
          <div className='feedback-list'>
            {feedbackFormatted}
          </div>
        </div>

      </div>
    );
  }
}

export default connect(({gameState, feedback, project, group}) => ({gameState, feedback, project, group}))(FeedbackOverview);



// WEBPACK FOOTER //
// ./src/components/routes/FeedbackOverview.js